import AssignmentWorkPackageModal from "@app/components/modals/assignments/assignment-work-package-modal.tsx";
import useWorkPackageData from "@app/data-hooks/use-work-package-data.ts";
import { assignmentWorkPackagesTableDefinition } from "@app/table-definitions/assignment-work-packages.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentWorkPackagesForm({ id }: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [packageId, setPackageId] = useState<number>();

    const { workPackagesListByAssignment, updateWorkPackageActivation, updateWorkPackageSortBy } = useWorkPackageData({
        assignmentId: id,
    });

    return (
        <>
            <AssignmentWorkPackageModal
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setPackageId(undefined);
                }}
                workPackageId={packageId}
                assignmentId={id}
            />
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Work Packages"}
                actions={
                    <Button variant={"contained"} onClick={() => setDialogOpen(true)}>
                        Add New
                    </Button>
                }
                columns={assignmentWorkPackagesTableDefinition({
                    onEdit: (id) => {
                        setDialogOpen(true);
                        setPackageId(id);
                    },
                    onActivateDeactivate: (id, active) =>
                        updateWorkPackageActivation.mutate({
                            workPackageId: id,
                            isActive: active,
                        }),
                    onUpdateSortBy: (id, sortBy) => updateWorkPackageSortBy.mutate({ packageId: id, sortBy }),
                    minSort: 1,
                    maxSort: workPackagesListByAssignment.data?.length ?? 1,
                    rowCount: workPackagesListByAssignment.data?.length ?? 0,
                })}
                data={workPackagesListByAssignment.data ?? []}
                initialSorting={[{ id: "sortBy", desc: false }]}
                queryHook={workPackagesListByAssignment}
                initialColumnVisibility={{ sortBy: false }}
            />
        </>
    );
}
